import React from 'react';

interface Props {
  attributes: any;
  children: any;
}

const DefaultElement = (props: Props) => {
  const { attributes, children } = props;
  return <div {...attributes}>{children}</div>;
};

export default DefaultElement;
